var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #898989;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u6587\\u5B57",
    "data-name": "\\u6587\\u5B57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.65,19.96l-4.71-4.71c1.24-1.6,1.99-3.6,1.99-5.78C18.93,4.25,14.68,0,9.47,0S0,4.25,0,9.47s4.25,9.47,9.47,9.47c2.18,0,4.18-.75,5.78-1.99l4.71,4.71c.23.23.53.35.85.35s.62-.13.85-.35c.47-.47.47-1.23,0-1.69ZM9.47,2.39c3.9,0,7.07,3.17,7.07,7.07s-3.17,7.07-7.07,7.07-7.07-3.17-7.07-7.07,3.17-7.07,7.07-7.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a261a30c53eb60495a54ec4467fb281f.svg";
export { ForwardRef as ReactComponent };